export default __webpack_public_path__ + "static/media/hakkei.c06a6ac7.png";